import htmx from "htmx.org";
import * as bootstrap from "bootstrap";

function main() {
    /**
   * Toasts / Hinweisboxen initialisieren
   */
  let showToasts = function () {
    $messages = document.getElementById("frontend-messages");

    if ($messages === undefined || $messages === null) return;

    $messages.querySelectorAll(".toast").forEach((el) => {
      const toast = new bootstrap.Toast(el);
      toast.show();
    });
  };

  showToasts();
  document.body.addEventListener("htmx:afterSwap", (e) => {
    showToasts();

    if (e.target.id === "modals") {
      const $modal = e.target.querySelector("#ksModal");
      const m = new bootstrap.Modal($modal);
      m.show();

      $modal.addEventListener("submit", () => {
        m.hide();
      });

      $modal.addEventListener("shown.bs.hidden", () => {
        m.dispose();
      });
    }
  });

   /**
   * Select-Boxen initialisieren
   */
   document.body.querySelectorAll(".tom-select").forEach((el) => {
    new TomSelect(el, {});
  });

  /**
   * Bestätigungsmodal bauen
   */
  let $confirmModal = document.querySelector("#confirmModal");
  if ($confirmModal !== undefined && $confirmModal !== null) {
    const confirmModal = new bootstrap.Modal($confirmModal);

    document.body.addEventListener("click", (ev) => {
      const $el = ev.target.closest("[data-confirm-modal]");
      if ($el === null || $el === undefined) return;
      const $form = document.querySelector("#" + $el.getAttribute("form"));
      if ($form === null || $form === undefined) return;

      ev.preventDefault();
      confirmModal._dialog.querySelector("h3").innerHTML =
        $form.dataset.confirmTitle;
      confirmModal._dialog.querySelector("span").innerHTML =
        $form.dataset.confirmText;
      confirmModal._dialog
        .querySelector("button[data-confirm-submit]")
        .addEventListener("click", (ev) => {
          ev.preventDefault();
          $form.submit();
          confirmModal.hide();
        });
      confirmModal.show();
    });
  }
}

if (document.readyState == "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }
  